export const assistantActionCompletedEvent = 'apl-enterprise:assistant-action-completed'

export type AssistantActionCompletedDetail = {
  route: string | null
  code: string
  affectedRecords: number
}

export function notifyAssistantActionCompleted(detail: AssistantActionCompletedDetail) {
  window.dispatchEvent(new CustomEvent<AssistantActionCompletedDetail>(
    assistantActionCompletedEvent, { detail },
  ))
}
